define(function(require, exports, module) {
    var core = require('core');
    var NotificationManager = require('managers/notification.manager');

    var originalInitialize = NotificationManager.prototype.initialize;

    NotificationManager.prototype.initialize = function() {
        NotificationManager.prototype.addCallback(31135, this, '_onBetPlacedReceived');

        originalInitialize.apply(this, arguments);
    };

    NotificationManager.prototype._onBetPlacedReceived = function(response) {
        var token = response && response.data && response.data.actionId;

        if (!token) {
            return;
        }

        core.trigger('game:bet-placed');
    };

    module.exports = NotificationManager;
});